import * as React from 'react';
import * as AnimationConfig from './animationConfig.json';
import { keyframes, style } from 'typestyle';

const shakeAnimation = keyframes({
  'from, to': { transform: 'translate3d(0, 0, 0)' },
  '15%, 45%, 75%': { transform: 'translate3d(-3px, 0, 0)' },
  '30%, 60%, 90%': { transform: 'translate3d(3px, 0, 0)' },
});

const errorAppearActive = style({
  opacity: 1,
  animation: `${shakeAnimation} ${AnimationConfig.ERROR_SHAKE_MS}ms linear 0s 1 normal`,
});

export function shakeInputIfInvalid(
  shouldShake: boolean,
  inputRef: React.RefObject<HTMLInputElement>
): React.EffectCallback {
  return () => {
    if (shouldShake && inputRef.current) {
      inputRef.current.classList.add(errorAppearActive);
      inputRef.current.focus();
      setTimeout(
        (el: React.RefObject<HTMLInputElement>) => {
          if (el.current) {
            el.current.classList.remove(errorAppearActive);
          }
        },
        AnimationConfig.ERROR_SHAKE_MS,
        inputRef
      );
    }
  };
}
